import React, { useEffect, useState, useRef } from "react";
import {
  Tabs,
  Heading,
  DateInput,
  NumberInput,
  Text,
  IconButton,
  Panel,
  toaster,
  Message,
  Drawer,
  Carousel,
  List,
  Modal,
  Textarea,
  Tag,
  Loader,
  SelectPicker,
  Box,
  Col,
  Row,
} from "rsuite";
import {
  Alert,
  Button,
  Form,
  Input,
  Select,
  Card,
  Table as TableAntd,
  Space,
  notification,
  Popconfirm,
} from "antd";
import { SearchOutlined, EditOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import {
  getDatosPaciente,
  getPacientes,
  getEstadosMedicosPac,
  getNombreDuplicado,
  getResumenDocs,
  saveEstadoMedicoPac,
  savePaciente,
  saveDocumento,
  saveAuthReq,
  eliminaDocExped,
} from "../Services/PacientesServices";
import {
  getDatosCitaPorIdConsulta,
  getDocsCita,
} from "../Services/ConsultasServices";
import {
  getFormaciones,
  getEntidades,
  getMunicipios,
  getNaciones,
  getReligiones,
  getRequisitos,
  getDocsEntregados,
} from "../Services/CatalogosServices";
import {
  FaArchive,
  FaFolder,
  FaList,
  FaPlusCircle,
  FaSave,
  FaUser,
} from "react-icons/fa";

import { useReactToPrint } from "react-to-print";
import { LucideTrash, Save, SearchIcon } from "lucide-react";
import Table from "react-bootstrap/Table";
import { confApp } from "../../CONF_APP";
import moment from "moment/moment";
import { LayoutHome } from "../LayoutHome";

export const Pacientes = () => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);

  const [idReq, setIdReq] = useState(0);
  const [nombreMedico] = useState(
    JSON.parse(localStorage.getItem("auth")).medico.medico,
  );

  const [negocio] = useState(
    JSON.parse(localStorage.getItem("auth")).consultorio,
  );
  const [appConfigParams] = useState(
    JSON.parse(localStorage.getItem("auth")).confApp,
  );

  const fileInputRef = useRef(null);
  const componentRef = useRef();

  const [loaderVisible, setLoaderVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Initial check
  const idMedico = JSON.parse(localStorage.getItem("auth")).idMedico;
  const idUser = JSON.parse(localStorage.getItem("auth")).idUser;
  const [disabledAnteced] = useState(idMedico === 0 ? true : false);
  const [disabledDocs, setDisabledDocs] = useState(true);
  const [disabledExped] = useState(idMedico === 0 ? true : false);
  const [data, setData] = useState([]);
  const [dataExped, setDataExped] = useState([]);
  const [open, setOpen] = useState(false);
  const [tituloDrawer, setTituloDrawer] = useState("");
  const [diagnostico, setDiagnostico] = useState("");
  const [dataSignosEx, setdataSignosEx] = useState([]);
  const [tratamiento, setTratamiento] = useState("");
  const [indicaciones, setIndicaciones] = useState("");
  const [motivoEx, setMotivoEx] = useState("");
  const [cambioFecha, setCambioFecha] = useState(false);
  const [nuevoPac, setNuevoPac] = useState(false);
  const [modalValida, setModalValida] = useState(false);
  const [documentoAValidar, setDocumentoAValidar] = useState("");
  const [listaVisible, setListaVisible] = useState(true);

  const [valueGpo1, setValueGpo1] = useState("");
  const [valueGpo2, setValueGpo2] = useState("");
  const [valueGpo3, setValueGpo3] = useState("");
  const [valueGpo4, setValueGpo4] = useState("");

  const [sortColumn, setSortColumn] = useState();
  const [sortType, setSortType] = useState();

  const [sortColumnExped, setSortColumnExped] = useState();
  const [sortTypeExped, setSortTypeExped] = useState();

  const [loading, setLoading] = useState(false);
  const [loadingExped, setLoadingExped] = useState(false);

  const [filtro, setFiltro] = useState("NULL");
  const [expediente, setExpediente] = useState(false);
  const [listReqs, setListReqs] = useState([]);
  const [listDocsEntreg, setListDocsEntreg] = useState([]);
  const [listEdosMedicos, setListEdosMedicos] = useState([
    { label: "Sin estado", value: "" },
    { label: "Positivo", value: "Positivo" },
    { label: "Grave", value: "Grave" },
  ]);
  const [estadoMedIni, setEstadoMedIni] = useState("");
  const [estadoMedActual, setEstadoMedActual] = useState("");
  const [sinDatos, setSinDatos] = useState(0);

  const [modalOpenReqs, setModalOpenReqs] = useState(false);

  const [form] = Form.useForm();
  const [formLayout] = useState("horizontal");

  // CONSTANTES DATOS DEL PACIENTE
  const [paciente, setPaciente] = useState("");
  const [idConsulta, setIdConsulta] = useState(0);
  const [observaCita, setObservaCita] = useState("");
  const [idPac, setIdPac] = useState(0);
  const [fecNac, setFecNac] = useState("");
  const [listaNacion, setListaNacion] = useState([]);
  const [estado, setEstado] = useState([]);
  const [municipio, setMunicipio] = useState([]);
  const [dataNivelEstud, setDataNivEstud] = useState([]);

  const [codPais, setCodPais] = useState(0);
  const [cambioCodPais, setCambioCodPais] = useState(false);
  const [cambioReligion, setCambioReligion] = useState(false);
  const [idReligion, setIdReligion] = useState(0);
  const [cambioEntidad, setCambioEntidad] = useState(false);
  const [idEntidad, setIdEntidad] = useState("00");
  const [cambioFormacion, setCambioFormacion] = useState(false);
  const [idFormacion, setIdFormacion] = useState(0);
  const [cambioMuni, setCambioMuni] = useState(false);
  const [idMuni, setIdMuni] = useState("0");

  const [listReligion, setListReligiones] = useState([]);
  const [edad, setEdad] = useState(0);

  const printerRef = React.useRef(null);

  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);
  const [showMsjDup, setShowMsjDup] = useState(false);
  const [pacientes, setPacientes] = useState(0);
  const [conDocs, setConDocs] = useState(0);
  const [sinDocs, setSinDocs] = useState(0);
  const [api, contextHolder] = notification.useNotification();

  const errorNotificaction = (title, msj) => {
    api.error({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#FFE4E0" } },
      showProgress: true,
    });
  };

  const contentStyle = {
    padding: 50,
    background: "rgba(0, 0, 0, 0.05)",
    borderRadius: 4,
  };

  const content = <div style={contentStyle} />;

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{ padding: 8 }}
        onKeyDown={(e) => e.stopPropagation()}
        tabIndex={"-1"}
      >
        <Input
          ref={searchInput}
          autoFocus
          placeholder={`Buscar ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Buscar
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Resetear
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filtrar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Cerrar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: {
      onOpenChange(open) {
        if (open) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const [listEdoCivil] = useState([
    { label: "", value: "" },
    { label: "Soltero(a)", value: "Soltero(a)" },
    { label: "Casado(a)", value: "Casado(a)" },
    { label: "Divorciado(a)", value: "Divorciado(a)" },
    { label: "Viudo(a)", value: "Viudo(a)" },
    { label: "Union Libre", value: "Union Libre" },
    { label: "Otro", value: "Otro" },
  ]);

  const [listGeneros] = useState([
    { label: "", value: "" },
    { label: "Femenino", value: "Femenino" },
    { label: "Masculino", value: "Masculino" },
    { label: "Otro", value: "Otro" },
  ]);

  const [listaAnteced, setListaAnteced] = useState([
    { nombre: "", detalles: [] },
  ]);

  const [imageList, setImageList] = useState([{ doc: "", tipoDoc: "" }]);
  const [link] = useState(confApp.LINK_DOC);
  const [modalReceta, setModalReceta] = useState(false);

  // ------------------------------------------------------------ HISTORICOS DE EXPLORACION ------------------------------
  const [frecCardiacaEx, setFrecCardiacaEx] = useState("");
  const [frecRespEx, setFrecRespEx] = useState("");
  const [tempEx, setTempEx] = useState("");
  const [presionArtEx, setPresioArtEx] = useState("");
  const [pesoEx, setPesoEx] = useState("");
  const [tallaEx, setTallaEx] = useState("");
  const [imcEx, setImcEx] = useState("");
  const [saturaOxEx, setSaturaOxEx] = useState("");
  const [glicemiaCapEx, setGlicemiaCapEx] = useState("");
  const [otrosDatosExploraEx, setOtrosDatosExploraEx] = useState("");
  const [labsEstudiosEx, setLabsEstudiosEx] = useState("");
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> FIN DE VARIABLES DE EXPLORACION FISICA

  const toast = (msg, type = "info") => {
    toaster.push(
      <Message showIcon type={type} closable>
        <strong>{type}!</strong>
        &nbsp; {msg}
      </Message>,
      { duration: 5000, placement: "topCenter" },
    );
  };

  const divMobile = {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    maxWidth: "1680px",
    height: "auto",
    padding: "20px",
    margin: "0 auto",
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleSortColumn = (sortColumn, sortType) => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setSortColumn(sortColumn);
      setSortType(sortType);
    }, 500);
  };

  const handleSortColumnExped = (sortColumn, sortType) => {
    setLoadingExped(true);
    setTimeout(() => {
      setLoadingExped(false);
      setSortColumnExped(sortColumn);
      setSortTypeExped(sortType);
    }, 500);
  };

  const getPageMargins = (marginTop, marginRight, marginBottom, marginLeft) => {
    return `@page { margin: ${marginTop} ${marginRight} ${marginBottom} ${marginLeft} !important; }`;
  };

  const marginTop = "55mm";
  const marginRight = "25mm";
  const marginBottom = "25mm";
  const marginLeft = "25mm";

  const handlePrint = useReactToPrint({
    documentTitle: "Receta",
    contentRef: componentRef,
    pageStyle: getPageMargins(marginTop, marginRight, marginBottom, marginLeft),
  });

  const loadPacientes = async () => {
    if (!filtro) {
      await setFiltro("NULL");
    }
    await getPacientes(idNegocio, filtro)
      .then(async (response) => {
        setData(response);
        const res = response.filter(
          (e) => e.estatusDatos === "Incompletos",
        ).length;
        setSinDatos(res);
        setListaVisible(true);
        await getResumenDocs(idNegocio).then((res) => {
          setPacientes(res[0].pacientes);
          setConDocs(res[0].conDocs);
          setSinDocs(res[0].sinDocs);
        });
      })
      .catch((error) => {
        if (error.status === 401) {
          toast("Debe iniciar sesión, antes de continuar...", "error");
          setTimeout(() => {
            window.location = `/#/App`;
          }, 1200);
        }
      });
  };

  const handleClose = () => {
    setModalReceta(false);
  };

  const getListaRequisitos = async () => {
    const result = await getRequisitos(idNegocio);
    setListReqs(result);
    setDisabledDocs(true);
  };

  const getDatosCita = async (idCons) => {
    const response = await getDatosCitaPorIdConsulta(idNegocio, idCons);
    // DATOS DE EXPLORACION FISICA
    setFrecCardiacaEx(response.dataSignos.frecCardiaca);
    setFrecRespEx(response.dataSignos.frecResp);
    setTempEx(response.dataSignos.temp);
    setPresioArtEx(response.dataSignos.presionArt);
    setPesoEx(response.dataSignos.peso);
    setTallaEx(response.dataSignos.talla);
    setImcEx(response.dataSignos.imc);
    setSaturaOxEx(response.dataSignos.saturaOx);
    setGlicemiaCapEx(response.dataSignos.glicemiaCap);
    setOtrosDatosExploraEx(response.dataSignos.otrosDatosExp);
    setLabsEstudiosEx(response.dataSignos.labsEstudios);
    setdataSignosEx(response.dataExplora);
    setMotivoEx(response.motivo);
    setIdConsulta(response.idConsulta);

    await getDocsCita(response.idConsulta).then((res) => {
      let doc = [];
      res.data.forEach((element) => {
        doc.push({ doc: element.NombreDoc, tipoDoc: element.tipoDoc });
      });
      setImageList(doc);
    });
  };

  const getPaciente = async (_idPac) => {
    await getDatosPaciente(idNegocio, _idPac)
      .then(async (response) => {
        await loadCatalogos(false).then(async (next) => {
          setNuevoPac(false);
          setIdPac(_idPac);
          setExpediente(true);

          let _fecha = response.fechaNac;
          if (_fecha !== null) {
            var _fecNac = new Date(response.fechaNac);
            _fecNac.setDate(_fecNac.getDate() + 1);
            calculaEdad(_fecNac);
            setFecNac(_fecNac);
          } else {
            setEdad(0);
            setFecNac(null);
          }

          setCambioCodPais(false);
          setCambioEntidad(false);
          setCambioMuni(false);
          setCambioReligion(false);
          setCambioFormacion(false);

          setPaciente(response.paciente);
          setCodPais(response.codPais);
          setIdEntidad(response.idEntidad);
          setIdMuni(response.idMun);
          setIdFormacion(response.idFormacion);
          setIdReligion(response.idReligion);
          setEstadoMedIni(response.edoMedIni);
          setEstadoMedActual(response.edoMedAct);

          form.setFieldsValue({
            paciente: response.paciente,
            fechaNac: _fecNac,
            telefono: response.telefono,
            correo: response.correo,
            calleNum: response.calleNum,
            colonia: response.colonia,
            codPostal: response.codPostal,
            idEntidad: response.idEntidad,
            idMuni: response.municipio,
            contacto1: response.contacto1,
            relacion1: response.relacion1,
            telContacto1: response.telContacto1,
            contacto2: response.contacto2,
            relacion2: response.relacion2,
            telContacto2: response.telContacto2,
            codPais: response.pais,
            edoCivil: response.edoCivil,
            genero: response.genero === null ? "" : response.genero,
            idFormacion: response.nivelEstud,
            idReligion: response.religion,
          });

          setDisabledDocs(false);

          await getDocsEntregados(idNegocio, _idPac).then((next) => {
            setListDocsEntreg(next);
          });
        });
        setLoaderVisible(false);
        // const _result = getAntecedentes(idNegocio, _idPac);
        // setListaAnteced(_result);
        // getExpedientePaciente(_idPac);
      })
      .catch((error) => {
        errorNotificaction(error.name, error.message);
        setLoaderVisible(false);
      });
  };

  const columns = [
    {
      title: "Estatus",
      dataIndex: "estatus",
      width: "5%",
      key: "estatus",
      render: (text, record) =>
        record.estatus === "Nuevo" ? (
          <Tag color="yellow" title="Documentación pendiente por entregar...">
            {record.estatus}
          </Tag>
        ) : text === "Activo" ? (
          <Tag color="green">Activo</Tag>
        ) : (
          <Tag color="red">Inactivo</Tag>
        ),
    },
    {
      title: "Paciente",
      dataIndex: "paciente",
      width: "25%",
      key: "paciente",
      ...getColumnSearchProps("paciente"),
      sorter: (a, b) => a.paciente.length - b.paciente.length,
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Docs. Entregados",
      dataIndex: "docsEntregados",
      width: "10%",
      key: "docsEntregados",
      align: "center",
      ...getColumnSearchProps("docsEntregados"),
      sorter: (a, b) => a.docsEntregados.length - b.docsEntregados.length,
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Datos",
      dataIndex: "estatusDatos",
      width: "8%",
      key: "estatusDatos",
      align: "center",
      ...getColumnSearchProps("estatusDatos"),
      sorter: (a, b) => a.estatusDatos.length - b.estatusDatos.length,
      sortDirections: ["descend", "ascend"],
      render: (text) =>
        text === "Incompletos" ? (
          <Tag color="red">Incompletos</Tag>
        ) : (
          <Tag color="green">Completos</Tag>
        ),
    },
    {
      title: "Acción",
      dataIndex: "",
      key: "x",
      width: "5%",
      align: "center",
      render: (text, record) => (
        <Button
          title="Editar datos del paciente"
          onClick={(e) => {
            e.stopPropagation();
            showExpediente({
              idPaciente: record.idPaciente,
            });
          }}
          icon={<EditOutlined />}
          color="primary"
          variant="outlined"
        ></Button>
      ),
    },
    {
      title: "Teléfono",
      dataIndex: "telefono",
      key: "telefono",
      width: "10%",
      align: "center",
      ...getColumnSearchProps("telefono"),
    },
    {
      title: "Contacto(1)",
      dataIndex: "contacto1",
      key: "contacto1",
      width: "25%",
      ...getColumnSearchProps("contacto1"),
    },
    {
      title: "Tel. Contacto(1)",
      dataIndex: "telContacto1",
      key: "telContacto1",
      with: "10%",
      align: "center",
      ...getColumnSearchProps("telContacto1"),
    },
    {
      title: "Sesiones",
      dataIndex: "sesiones",
      key: "sesiones",
      width: "8%",
      align: "center",
    },
    {
      title: "Citas médicas",
      dataIndex: "citas",
      key: "citas",
      width: "8%",
      align: "center",
    },
    {
      title: "Consultas",
      dataIndex: "consultas",
      key: "consultas",
      width: "8%",
      align: "center",
    },
  ];

  const cleanForm = () => {
    setDisabledDocs(true);
    setListDocsEntreg([]);
    form.resetFields();
  };

  const save = async (values) => {
    if (!nuevoPac && !cambioCodPais) {
      values.codPais = codPais;
    }
    if (!nuevoPac && !cambioEntidad) {
      values.idEntidad = idEntidad;
    }
    if (!nuevoPac && !cambioMuni) {
      values.idMuni = idMuni;
    }
    if (!nuevoPac && !cambioFormacion) {
      values.idFormacion = idFormacion;
    }
    if (!nuevoPac && !cambioReligion) {
      values.idReligion = idReligion;
    }

    const newObj = { ...values, id: idNegocio, idPaciente: idPac };

    await savePaciente(newObj).then(async (nxt) => {
      if (nxt.data > 0) {
        setPaciente(values.paciente);
        setIdPac(nxt.data);
        setDisabledDocs(false);
        toast("Los datos se han actualizado de forma correcta.", "success");
        if (nuevoPac) {
          await getDocsEntregados(idNegocio, nxt.data).then((next) => {
            setListDocsEntreg(next);
          });
        }
      }
    });
  };

  const getData = () => {
    if (sortColumn && sortType) {
      return data.sort((a, b) => {
        let x = a[sortColumn];
        let y = b[sortColumn];
        if (typeof x === "string") {
          x = x.charCodeAt();
        }
        if (typeof y === "string") {
          y = y.charCodeAt();
        }
        if (sortType === "asc") {
          return x - y;
        } else {
          return y - x;
        }
      });
    }
    return data;
  };

  const getDataExped = () => {
    if (sortColumn && sortType) {
      return dataExped.sort((a, b) => {
        let x = a[sortColumn];
        let y = b[sortColumn];
        if (typeof x === "string") {
          x = x.charCodeAt();
        }
        if (typeof y === "string") {
          y = y.charCodeAt();
        }
        if (sortType === "asc") {
          return x - y;
        } else {
          return y - x;
        }
      });
    }
    return dataExped;
  };

  const calculaEdad = (e) => {
    const hoy = new Date(); // Fecha actual
    const fechaNac = new Date(e); // Fecha de nacimiento del input

    let edad = hoy.getFullYear() - fechaNac.getFullYear(); // Diferencia de años inicial

    const mesActual = hoy.getMonth();
    const mesNac = fechaNac.getMonth();

    // Si el mes actual es menor que el mes de nacimiento, no ha cumplido años
    if (mesActual < mesNac) {
      edad--;
    } else if (mesActual === mesNac) {
      // Si los meses son iguales, revisamos el día
      const diaActual = hoy.getDate();
      const diaNac = fechaNac.getDate();
      if (diaActual < diaNac) {
        edad--; // No ha cumplido años aún en el mes actual
      }
    }

    // Para obtener meses y días exactos (más complejo, pero posible)
    // Se puede calcular la diferencia en milisegundos y convertir, o iterar meses/días
    // El método anterior solo da los años cumplidos.
    setEdad(edad);
  };

  const handleChangeValueExplora = (e, idGpo) => {
    if (idGpo === 1) {
      setValueGpo1(e);
    }
    if (idGpo === 2) {
      setValueGpo2(e);
    }
    if (idGpo === 3) {
      setValueGpo3(e);
    }
    if (idGpo === 4) {
      setValueGpo4(e);
    }
  };

  const handleFechaNac = (e) => {
    var esFecha = moment(e, "DD/MM/YYYY").isValid();
    if (esFecha) {
      var fec = new Date(e).toISOString();
      var fecha = moment(fec).format("DD/MM/YYYY");
      setFecNac(fecha);

      const hoy = new Date(); // Fecha actual
      const fechaNac = new Date(e); // Fecha de nacimiento del input

      let edad = hoy.getFullYear() - fechaNac.getFullYear(); // Diferencia de años inicial

      const mesActual = hoy.getMonth();
      const mesNac = fechaNac.getMonth();
      setCambioFecha(true);
      // Si el mes actual es menor que el mes de nacimiento, no ha cumplido años
      if (mesActual < mesNac) {
        edad--;
      } else if (mesActual === mesNac) {
        // Si los meses son iguales, revisamos el día
        const diaActual = hoy.getDate();
        const diaNac = fechaNac.getDate();
        if (diaActual < diaNac) {
          edad--; // No ha cumplido años aún en el mes actual
        }
      }

      // Para obtener meses y días exactos (más complejo, pero posible)
      // Se puede calcular la diferencia en milisegundos y convertir, o iterar meses/días
      // El método anterior solo da los años cumplidos.
      setEdad(edad);
    }
  };

  const showExpediente = async (props) => {
    setLoaderVisible(true);
    setListaVisible(false);
    const dataPaciente = {
      idPaciente: props.idPac,
    };
    localStorage.setItem("dataPaciente", JSON.stringify(dataPaciente));
    getPaciente(props.idPaciente);
  };

  const getFinalText = (text) => {
    const lines = text.split("\n");
    return (
      <div>
        {lines.map((item, index) => (
          <React.Fragment key={index}>
            {item}
            {index < lines.length - 1 && <br />}
          </React.Fragment>
        ))}
      </div>
    );
  };

  const confirm = (props) =>
    new Promise(async (resolve) => {
      const data = {
        id: idNegocio,
        idPaciente: idPac,
        idReq: props.idReq,
        noItem: props.noItem,
      };

      await eliminaDocExped(data)
        .then(async (res) => {
          if (res.data > 0) {
            await getDocsEntregados(idNegocio, idPac).then((next) => {
              setListDocsEntreg(next);
              resolve(null);
            });
          } else {
            errorNotificaction(
              "Error",
              "No se ha podido eliminar el docuemtno",
            );
            resolve(null);
          }
        })
        .catch((err) => {
          errorNotificaction(err.name, err.message);
          resolve(null);
        });
    });

  const uploadDoc = async (e, props) => {
    const formData = new FormData();
    formData.append("id", idNegocio);
    formData.append("idPac", idPac);
    formData.append("file", e.target.files[0]);
    formData.append("idReq", props.idReq);

    await saveDocumento(formData).then(async (next) => {
      if (next.data !== "") {
        toast("El documento se ha cargado de forma correcta", "success");
        await getDocsEntregados(idNegocio, idPac).then((next) => {
          setListDocsEntreg(next);
        });
      } else {
        toast("Ocurrio un error al guardar el documento", "error");
      }
    });
  };

  const loadCatalogos = async (esNuevo) => {
    setListaVisible(false);
    setNuevoPac(esNuevo);
    setIdPac(0);
    setPaciente("Nuevo");
    cleanForm();
    setFecNac("");
    setEdad(0);
    setCambioCodPais(false);
    setCambioEntidad(false);
    setCambioMuni(false);
    setCambioReligion(false);
    setCambioFormacion(false);

    await getEntidades().then(async (nxt) => {
      setEstado(nxt);
      await getNaciones().then(async (res) => {
        setListaNacion(res);
        await getFormaciones().then(async (res) => {
          setDataNivEstud(res);
          await getReligiones().then(async (res) => {
            setListReligiones(res);
            await getListaRequisitos();
            setModalOpenReqs(esNuevo);
          });
        });
      });
    });
  };

  const handleCloseModalValida = () => {
    setModalValida(false);
  };

  const openModalValida = (props) => {
    setModalValida(true);
    setIdReq(props.idReq);
    setDocumentoAValidar(props.documento);
  };

  const loadMunicipios = async (e) => {
    setCambioEntidad(true);
    const result = await getMunicipios(e);
    setMunicipio(result);
  };

  const validateMessages = {
    required: "* Obligatorio",
    types: {
      email: "* El campo de correo no es valido",
      number: "* El campo no es un número!",
    },
    number: {
      range: "${label} must be between ${min} and ${max}",
    },
  };

  const saveAuthRequisito = async () => {
    const data = {
      id: idNegocio,
      idPac: idPac,
      idReq: idReq,
      idMedico: idMedico,
    };

    await saveAuthReq(data).then(async (next) => {
      if (next.data > 0) {
        toast("Se ha validado el documento de forma correcta.", "success");
        await getDocsEntregados(idNegocio, idPac).then((next) => {
          setListDocsEntreg(next);
          setModalValida(false);
        });
      } else {
        errorNotificaction(
          "Error",
          "Ocurrio un error al registrar la validación",
        );
      }
    });
  };

  const handleValidaDup = async (e) => {
    // Access the value directly from the event target
    const finalValue = e.target.value;
    await getNombreDuplicado(idNegocio, finalValue)
      .then((res) => {
        if (res !== "") {
          setShowMsjDup(true);
        } else {
          setShowMsjDup(false);
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const saveEdoMedico = async () => {
    if (idMedico === 0) {
      errorNotificaction(
        "Sin permiso",
        "El usuario no puede cambiar el estado médico.",
      );
      return;
    }
    const data = {
      id: idNegocio,
      idPac: idPac,
      esInicial: 1,
      estado: estadoMedIni,
    };
    await saveEstadoMedicoPac(data)
      .then(async (res) => {
        if (res.data > 0) {
          toast("Se ha registrado el estado médico inicial.", "success");
          await getEstadosMedicosPac(idNegocio, idPac).then((res) => {
            setEstadoMedIni(res.estatMedIni);
            setEstadoMedActual(res.estatMedActual);
          });
        } else {
          toast("Ocurrio un error al guardar el estado médico.", "error");
        }
      })
      .catch((error) => {
        toast(error.message, error.name);
      });
  };

  const handleCloseModalReqs = () => {
    setModalOpenReqs(false);
  };

  const habilitaBoton = (estatus, documento) => {
    let deshabilitado = true;

    if (estatus === "SIN VALIDAR" && documento !== "") {
      deshabilitado = false;
    }
    if (estatus === "VALLIDADO") {
      deshabilitado = true;
    }
    if (estatus === "NO APLICA" && documento !== "") {
      deshabilitado = false;
    }

    return deshabilitado;
  };

  const getDetalles = async (props) => {
    getDatosCita(props.idC);
    setTituloDrawer(props.titulo);
    setDiagnostico(props.diagnostico);
    setTratamiento(props.tratamiento);
    setIndicaciones(props.indicaciones);
    setObservaCita(props.observa);
    setOpen(true);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Update on resize
    };
    window.addEventListener("resize", handleResize);
    loadPacientes();
    return () => {
      window.removeEventListener("resize", handleResize); // Cleanup
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <LayoutHome
        titleItems={[
          {
            title: (
              <a href="/#/App/Home" style={{ textDecoration: "none" }}>
                Menú
              </a>
            ),
          },
          { title: "Pacientes" },
        ]}
        selectedKey={"3"}
      >
        {contextHolder}
        <Form layout={formLayout}>
          <div className="row mb-2">
            <div className="col-lg-3 col-md-3">
              <Button
                block
                type="primary"
                icon={<FaList></FaList>}
                onClick={() => loadPacientes()}
              >
                Lista de pacientes
              </Button>
            </div>
            &nbsp;
            <div className="col-lg-3 col-md-3 col-sm-3">
              <Button
                block
                type="primary"
                icon={<FaPlusCircle></FaPlusCircle>}
                onClick={() => loadCatalogos(true)}
              >
                Nuevo paciente
              </Button>
            </div>
          </div>
        </Form>
        {listaVisible ? (
          <div style={{ overflowX: isMobile ? "scroll" : "none" }}>
            <div className="row">
              <div className="col">
                <TableAntd
                  bordered
                  size="small"
                  rowKey={(record) => record.idPaciente}
                  columns={columns}
                  dataSource={data}
                  pagination={{ pageSize: 10 }}
                />
              </div>
            </div>
            {isMobile ? (
              ""
            ) : (
              <Row gutter={10} padding={"10px"}>
                <Col span={6}>
                  <Box
                    bd="1px solid var(--rs-border-primary)"
                    rounded="lg"
                    p={10}
                    style={{ textAlign: "center" }}
                  >
                    <Text size={"lg"} color={"black"}>
                      Pacientes: {pacientes}
                    </Text>
                  </Box>
                </Col>
                <Col span={6}>
                  <Box
                    bd="1px solid var(--rs-border-primary)"
                    rounded="lg"
                    p={10}
                    style={{ textAlign: "center" }}
                  >
                    <Text size={"lg"} color={"red"}>
                      Pacientes con datos incompletos: {sinDatos}
                    </Text>
                  </Box>
                </Col>
                <Col span={6}>
                  <Box
                    bd="1px solid var(--rs-border-primary)"
                    rounded="lg"
                    p={10}
                    style={{ textAlign: "center" }}
                  >
                    <Text size={"lg"} color={"black"}>
                      Pacientes con documentos: {conDocs}
                    </Text>
                  </Box>
                </Col>
                <Col span={6}>
                  <Box
                    bd="1px solid var(--rs-border-primary)"
                    rounded="lg"
                    p={10}
                    style={{ textAlign: "center" }}
                  >
                    <Text size={"lg"} color={"red"}>
                      Pacientes sin documentos: {sinDocs}
                    </Text>
                  </Box>
                </Col>
              </Row>
            )}
          </div>
        ) : expediente || nuevoPac ? (
          <>
            {loaderVisible ? (
              <>
                <br></br>
                <center>
                  <Loader content="Cargando..." size="lg" />
                </center>
              </>
            ) : (
              <>
                <center style={{ padding: "5px" }}>
                  <Heading
                    level={isMobile ? 9 : 5}
                    style={{
                      fontFamily: "Arial Narrow",
                      backgroundColor: "#F0F0F0",
                      padding: "5px",
                      borderRadius: "7px",
                    }}
                  >
                    Paciente: {paciente}
                  </Heading>
                </center>

                <Tabs
                  defaultActiveKey="1"
                  bordered
                  appearance={isMobile ? "subtle" : "tabs"}
                  style={{ fontSize: isMobile ? "12px" : "16px" }}
                >
                  {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> TAB DATOS GENERALES */}
                  <Tabs.Tab
                    eventKey="1"
                    title={isMobile ? <FaUser></FaUser> : "Datos Generales"}
                  >
                    <Card>
                      <Form
                        name="basic"
                        form={form}
                        layout="vertical"
                        variant="outlined"
                        initialValues={{ remember: true }}
                        onFinish={save}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"
                        validateMessages={validateMessages}
                      >
                        <div className="row">
                          <div className="col-lg-3 col-md-3 col-sm-3">
                            <Form.Item
                              name="paciente"
                              label={"Nombre completo"}
                              rules={[{ required: true }]}
                            >
                              <Input onBlur={(e) => handleValidaDup(e)} />
                            </Form.Item>
                          </div>
                          <div className="col-lg-2 col-md-2 col-sm-2">
                            <Form.Item
                              name="fechaNac"
                              label={"Fecha de nacimiento"}
                              rules={[{ required: true }]}
                            >
                              <DateInput
                                format="dd/MM/yyyy"
                                defaultValue={fecNac}
                                onChange={(e) => handleFechaNac(e)}
                              />
                            </Form.Item>
                          </div>

                          <div className="col-lg-1 col-md-1 col-sm-1">
                            <Form.Item label={"Edad"}>
                              <Input
                                readOnly
                                value={edad}
                                style={{ textAlign: "center" }}
                              />
                            </Form.Item>
                          </div>
                          <div className="col-lg-2 col-md-2 col-sm-2">
                            <Form.Item
                              name="telefono"
                              label={"Teléfono"}
                              rules={[{ required: true }]}
                            >
                              <NumberInput
                                controls={false}
                                id="telefono"
                                maxLength={10}
                                min={0}
                              />
                            </Form.Item>
                          </div>
                          <div className="col-lg-4 col-md-4 col-sm-4">
                            <Form.Item
                              label="Correo"
                              name={"correo"}
                              rules={[
                                {
                                  type: "email",
                                  message:
                                    "* No es un formato valido de correo",
                                },
                              ]}
                            >
                              <Input />
                            </Form.Item>
                          </div>
                        </div>
                        {showMsjDup ? (
                          <div className="row mb-2">
                            <Alert
                              title="El nombre del paciente se ha encontrado en la base, revisa que no exista..."
                              type="warning"
                              showIcon
                              closable
                            />
                          </div>
                        ) : (
                          ""
                        )}

                        <div className="row">
                          <div className="col-lg-3 col-md-3 col-sm-3">
                            <Form.Item
                              label="Calle y número"
                              name={"calleNum"}
                              rules={[{ required: true }]}
                            >
                              <Input autoComplete="off" />
                            </Form.Item>
                          </div>
                          <div className="col-lg-2 col-md-2 col-sm-2">
                            <Form.Item
                              label="Colonia"
                              name={"colonia"}
                              rules={[{ required: true }]}
                            >
                              <Input />
                            </Form.Item>
                          </div>
                          <div className="col-lg-1 col-md-1 col-sm-1">
                            <Form.Item
                              label="CP"
                              name={"codPostal"}
                              rules={[{ required: true }]}
                            >
                              <Input maxLength={5} />
                            </Form.Item>
                          </div>
                          <div className="col-lg-3 col-md-3 col-sm-3">
                            <Form.Item
                              label="Estado"
                              name={"idEntidad"}
                              rules={[{ required: true }]}
                            >
                              <Select
                                options={estado}
                                onChange={(e) => loadMunicipios(e)}
                                showSearch={{
                                  optionFilterProp: "label",
                                  filterSort: (optionA, optionB) =>
                                    (optionA?.label ?? "")
                                      .toLowerCase()
                                      .localeCompare(
                                        (optionB?.label ?? "").toLowerCase(),
                                      ),
                                }}
                                autoComplete="off"
                              />
                            </Form.Item>
                          </div>
                          <div className="col-lg-3 col-md-3 col-sm-3">
                            <Form.Item
                              label="Municipio"
                              name={"idMuni"}
                              rules={[{ required: true }]}
                            >
                              <Select
                                options={municipio}
                                showSearch={{
                                  optionFilterProp: "label",
                                  filterSort: (optionA, optionB) =>
                                    (optionA?.label ?? "")
                                      .toLowerCase()
                                      .localeCompare(
                                        (optionB?.label ?? "").toLowerCase(),
                                      ),
                                }}
                                onChange={() => setCambioMuni(true)}
                                autoComplete="off"
                              />
                            </Form.Item>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-3 col-md-3 col-sm-3">
                            <Form.Item
                              label="Contacto(1)"
                              name={"contacto1"}
                              rules={[{ required: true }]}
                            >
                              <Input />
                            </Form.Item>
                          </div>
                          <div className="col-lg-2 col-md-2 col-sm-2">
                            <Form.Item
                              label="Parentesco (1)"
                              name={"relacion1"}
                              rules={[{ required: true }]}
                            >
                              <Select
                                style={{ width: "100%" }}
                                options={confApp.RELACIONES}
                                block
                              />
                            </Form.Item>
                          </div>
                          <div className="col-lg-1 col-md-1 col-sm-1">
                            <Form.Item
                              label="Teléfono"
                              name={"telContacto1"}
                              rules={[{ required: true }]}
                            >
                              <Input maxLength={10} />
                            </Form.Item>
                          </div>

                          <div className="col-lg-3 col-md-3 col-sm-3">
                            <Form.Item label="Contacto(2)" name={"contacto2"}>
                              <Input />
                            </Form.Item>
                          </div>
                          <div className="col-lg-2 col-md-2 col-sm-2">
                            <Form.Item
                              label="Parentesco (2)"
                              name={"relacion2"}
                            >
                              <Select
                                style={{ width: "100%" }}
                                options={confApp.RELACIONES}
                                block
                              />
                            </Form.Item>
                          </div>
                          <div className="col-lg-1 col-md-1 col-sm-1">
                            <Form.Item label="Teléfono" name={"telContacto2"}>
                              <Input maxLength={10} />
                            </Form.Item>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-lg-2 col-md-2 col-sm-2">
                            <Form.Item
                              label="Nacionalidad"
                              name={"codPais"}
                              rules={[{ required: true }]}
                            >
                              <Select
                                autoComplete="off"
                                options={listaNacion}
                                showSearch={{
                                  optionFilterProp: "label",
                                  filterSort: (optionA, optionB) =>
                                    (optionA?.label ?? "")
                                      .toLowerCase()
                                      .localeCompare(
                                        (optionB?.label ?? "").toLowerCase(),
                                      ),
                                }}
                                onChange={() => setCambioCodPais(true)}
                              />
                            </Form.Item>
                          </div>
                          <div className="col-lg-2 col-md-2 col-sm-2">
                            <Form.Item label="Estado Civil" name={"edoCivil"}>
                              <Select options={listEdoCivil} />
                            </Form.Item>
                          </div>
                          <div className="col-lg-1 col-md-1 col-sm-1">
                            <Form.Item label="Genero" name={"genero"}>
                              <Select options={listGeneros} />
                            </Form.Item>
                          </div>
                          <div className="col-lg-4 col-md-4 col-sm-4">
                            <Form.Item
                              label="Formación académica"
                              name={"idFormacion"}
                              rules={[{ required: true }]}
                            >
                              <Select
                                options={dataNivelEstud}
                                showSearch={{
                                  optionFilterProp: "label",
                                  filterSort: (optionA, optionB) =>
                                    (optionA?.label ?? "")
                                      .toLowerCase()
                                      .localeCompare(
                                        (optionB?.label ?? "").toLowerCase(),
                                      ),
                                }}
                                onChange={() => setCambioFormacion(true)}
                              />
                            </Form.Item>
                          </div>
                          <div className="col-lg-3 col-md-3 col-sm-3">
                            <Form.Item
                              label="Religión"
                              name={"idReligion"}
                              rules={[{ required: true }]}
                            >
                              <Select
                                options={listReligion}
                                showSearch={{
                                  optionFilterProp: "label",
                                  filterSort: (optionA, optionB) =>
                                    (optionA?.label ?? "")
                                      .toLowerCase()
                                      .localeCompare(
                                        (optionB?.label ?? "").toLowerCase(),
                                      ),
                                }}
                                onChange={() => setCambioReligion(true)}
                              />
                            </Form.Item>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col">
                            <br></br>
                            <Button
                              icon={<FaSave></FaSave>}
                              type="primary"
                              htmlType="submit"
                              block
                            >
                              Guardar
                            </Button>
                          </div>
                        </div>
                      </Form>
                    </Card>
                  </Tabs.Tab>
                  {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> TAB DOCUMENTACIÓN <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
                  <Tabs.Tab
                    eventKey="2"
                    title={isMobile ? <FaArchive></FaArchive> : "Documentación"}
                    disabled={disabledDocs}
                  >
                    <Card>
                      <div className="row mb-3">
                        <div className="col">
                          <Text weight="semibold">Lista de Documentos</Text>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col">
                          <Table
                            striped
                            bordered
                            hover
                            responsive
                            key={`tbl-Docs`}
                            style={{
                              width: "100%",
                              cellPadding: "5",
                              cellSpacing: "10",
                              borderRadius: "15px",
                              fontSize: isMobile ? "10px" : "14px",
                            }}
                            cellPadding={10}
                            cellSpacing={10}
                          >
                            <thead>
                              <tr>
                                <th style={{ textAlign: "center" }}>
                                  <Text size={"sm"}>#</Text>
                                </th>
                                <th>
                                  <Text size={"sm"}>Requisito</Text>
                                </th>
                                <th style={{ textAlign: "center" }}>...</th>
                                <th>
                                  <Text size={"sm"}>Documento entregado</Text>
                                </th>
                                <th style={{ textAlign: "center" }}>
                                  <Text size={"sm"}>Fecha Entrega</Text>
                                </th>
                                <th style={{ textAlign: "center" }}>
                                  <Text size={"sm"}>Prox. Fecha</Text>
                                </th>
                                <th
                                  style={{ textAlign: "center", width: "7%" }}
                                >
                                  <Text size={"sm"}>Validado</Text>
                                </th>
                                <th>
                                  <Text size={"sm"}>Subir archivo...</Text>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {listDocsEntreg.length > 0 ? (
                                listDocsEntreg.map((item, index) => {
                                  return (
                                    <tr key={`fila-${item.idReq}`}>
                                      <td style={{ textAlign: "center" }}>
                                        {item.idReq}
                                      </td>
                                      <td>{item.nomReq}</td>
                                      <td style={{ textAlign: "center" }}>
                                        <Popconfirm
                                          title="Eliminar documento"
                                          description="¿Desea eliminar el documento?"
                                          okText="Si"
                                          onConfirm={() =>
                                            confirm({
                                              idReq: item.idReq,
                                              noItem: item.noItem,
                                            })
                                          }
                                          cancelText="No"
                                        >
                                          <Button
                                            size="small"
                                            icon={
                                              <LucideTrash
                                                size={12}
                                                color="red"
                                              ></LucideTrash>
                                            }
                                            disabled={habilitaBoton(
                                              item.estatus,
                                              item.documento,
                                            )}
                                          ></Button>
                                        </Popconfirm>
                                      </td>
                                      <td>
                                        <div key={index}>
                                          <a
                                            href={`Unidades/${idNegocio}/Expedientes/Pacientes/${idPac}/Documentos/${item.documento}`}
                                            target="_blank"
                                            rel="noreferrer"
                                          >
                                            {item.documento}
                                          </a>
                                        </div>
                                      </td>
                                      <td
                                        style={{
                                          textAlign: "center",
                                          width: "8%",
                                        }}
                                      >
                                        {item.fechaEntrega !== ""
                                          ? moment(item.fechaEntrega).format(
                                              "DD-MMM-YYYY",
                                            )
                                          : ""}
                                      </td>
                                      <td
                                        style={{
                                          textAlign: "center",
                                          width: "8%",
                                        }}
                                      >
                                        {item.proxFecha !== ""
                                          ? moment(item.proxFecha).format(
                                              "DD-MMM-YYYY",
                                            )
                                          : ""}
                                      </td>
                                      <td
                                        style={{
                                          textAlign: "center",
                                          color:
                                            item.estatus === "SIN VALIDAR"
                                              ? "red"
                                              : "black",
                                        }}
                                      >
                                        {item.estatus === "SIN VALIDAR" ? (
                                          idMedico === 0 ? (
                                            <Tag color="red">
                                              {item.estatus}
                                            </Tag>
                                          ) : (
                                            <Button
                                              color="red"
                                              variant="outlined"
                                              size="small"
                                              onClick={() => {
                                                openModalValida({
                                                  idReq: item.idReq,
                                                  documento: item.nomReq,
                                                });
                                              }}
                                            >
                                              SIN VALIDAR
                                            </Button>
                                          )
                                        ) : item.estatus === "VALIDADO" ? (
                                          <Tag color="green">
                                            {item.estatus}
                                          </Tag>
                                        ) : (
                                          <Tag color="#000">{item.estatus}</Tag>
                                        )}
                                      </td>
                                      <td>
                                        <input
                                          ref={fileInputRef}
                                          type="file"
                                          key={`file-${item.idReq}`}
                                          accept={item.accept}
                                          onChange={(e) =>
                                            uploadDoc(e, {
                                              idReq: item.idReq,
                                            })
                                          }
                                        ></input>
                                      </td>
                                    </tr>
                                  );
                                })
                              ) : (
                                <tr></tr>
                              )}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </Card>
                  </Tabs.Tab>
                  {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> TAB EDOS MEDICOS INICIALES <<<<<<<<<<<<<<<<<<<<<<<<<<< */}
                  <Tabs.Tab
                    eventKey="5"
                    title={
                      isMobile ? (
                        <FaFolder></FaFolder>
                      ) : (
                        "Estado Médico (inicial y actúal)"
                      )
                    }
                    disabled={disabledDocs}
                  >
                    <Panel header="Estado Médico (Inicial y Actúal)" bordered>
                      <div className="row mb-3">
                        <div className="col-lg-3 col-md-3 col-sm-3">
                          <Text size={"sm"} style={{ padding: "5px" }}>
                            Estado Médico Inicial
                          </Text>
                          <SelectPicker
                            block
                            placeholder="--Selecciona--"
                            value={estadoMedIni}
                            data={listEdosMedicos}
                            onChange={(e) => setEstadoMedIni(e)}
                          />
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-3">
                          <Text size={"sm"} style={{ padding: "5px" }}>
                            Estado Médico Actúal
                          </Text>
                          <Input
                            value={estadoMedActual}
                            readOnly
                            style={{ textAlign: "center" }}
                          />
                        </div>
                        <div className="col-lg-2 col-md-2 col-sm-2">
                          <br></br>
                          <Button
                            type="primary"
                            icon={<Save size={16}></Save>}
                            onClick={saveEdoMedico}
                          >
                            Guardar
                          </Button>
                        </div>
                      </div>
                    </Panel>
                  </Tabs.Tab>
                </Tabs>
              </>
            )}

            {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> MODAL RECETA MÉDICA */}
            <Modal size="lg" open={modalReceta} onClose={handleClose}>
              <Modal.Header>
                <Modal.Title>Indicaciones (Receta Médica)</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <hr></hr>
                <div ref={componentRef}>
                  <div className="row">
                    <div className="col">
                      <table style={{ width: "100%" }} border={0}>
                        <tr>
                          <td style={{ width: "50%" }}>{diagnostico}</td>
                          <td>{getFinalText(indicaciones)}</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
                <hr></hr>
              </Modal.Body>
              <Modal.Footer>
                <Button appearance="primary" onClick={handlePrint}>
                  Imprimir
                </Button>
              </Modal.Footer>
            </Modal>

            {/* *************************************************************** MODAL LISTA DE REQUISITOS **********************************  */}
            <Modal
              size="lg"
              open={modalOpenReqs}
              onClose={handleCloseModalReqs}
            >
              <Modal.Header>
                <Modal.Title>
                  Lista de documentos para nuevos pacientes
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Panel
                  bordered
                  style={{ padding: "15px" }}
                  header="Requisitos para nuevos pacientes, estos deberán adjuntarse al finalzar el alta."
                >
                  <div>
                    {listReqs.map((el) => {
                      return <li key={el.IdRequisito}>{el.NombreReq}</li>;
                    })}
                  </div>
                </Panel>
              </Modal.Body>
              <Modal.Footer>
                <Button appearance="primary" onClick={handleCloseModalReqs}>
                  Cerrar
                </Button>
              </Modal.Footer>
            </Modal>

            {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> MODAL PARA VALIDAR DOCUMENTO <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
            <Modal
              size="md"
              open={modalValida}
              onClose={handleCloseModalValida}
            >
              <Modal.Header>
                <Modal.Title>
                  Validación del documento ({nombreMedico})
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Panel bordered style={{ padding: "5px" }}>
                  <Card>
                    <div className="row">
                      <div
                        className="col-lg-2 col-md-2 col-sm-2"
                        style={{ textAlign: "left" }}
                      >
                        <Text size={"sm"} weight="medium">
                          <Tag color="#c5e7fc">Documento: </Tag>
                        </Text>
                      </div>
                      <div
                        className="text-left col-lg-10 col-md-10 col-sm-10"
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          float: "left",
                        }}
                      >
                        {documentoAValidar}
                      </div>
                    </div>
                  </Card>
                  <br></br>
                  <div className="row">
                    <div className="col">
                      <Button
                        type="primary"
                        onClick={() => saveAuthRequisito()}
                        block
                      >
                        Autorizar documento
                      </Button>
                    </div>
                  </div>
                </Panel>
              </Modal.Body>
              <Modal.Footer>
                <Button appearance="primary" onClick={handleCloseModalValida}>
                  Cerrar
                </Button>
              </Modal.Footer>
            </Modal>
          </>
        ) : (
          ""
        )}
      </LayoutHome>
    </>
  );
};
